import { Box } from '@mui/material';
import { LoadingState } from '@/components/LoadingState';

/**
 * What a page's slot shows while that page's code is downloading for the
 * first time. Rendered INSIDE the layouts (AppLayout, AuthLayout), so the
 * navigation stays on screen around it.
 */
export default function PageFallback({ minHeight = '60vh' }) {
  return (
    <Box sx={{ minHeight }}>
      <LoadingState label="Loading page..." />
    </Box>
  );
}
